import { Skeleton } from "../../components/ui/skeleton";
import { ArrowLeft } from "lucide-react";

export default function ProjectDetailsSkeleton() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 space-y-8 animate-in fade-in duration-500">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-slate-300 font-bold">
          <ArrowLeft className="w-5 h-5" />
          <Skeleton className="h-4 w-16" />
        </div>
        <Skeleton className="h-10 w-32 rounded-2xl" />
      </div>

      <div className="bg-white rounded-[3rem] border-2 border-slate-100 shadow-xl overflow-hidden">
        {/* Visual Section Skeleton */}
        <Skeleton className="h-96 sm:h-[600px] w-full" />

        {/* Content Section Skeleton */}
        <div className="p-8 sm:p-12 space-y-10">
          <div className="space-y-4">
            <Skeleton className="h-12 w-3/4" />
            <div className="flex gap-6">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-24" />
            </div>
          </div>

          <div className="p-8 bg-slate-50 rounded-[2rem] border border-slate-100 space-y-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
          </div>

          <div className="space-y-4">
            <Skeleton className="h-4 w-32" />
            <div className="flex flex-wrap gap-2">
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} className="h-8 w-24 rounded-xl" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
